(() => {
  let started = false;
  const start = () => {
  if (started) return;
  started = true;
  const gate = document.querySelector('[data-siw-age-gate]');
  if (!gate) return;
  const panel = gate.querySelector('.siw-age-gate__panel');
  const yes = gate.querySelector('[data-siw-age-yes]');
  const no = gate.querySelector('[data-siw-age-no]');
  const underage = gate.querySelector('[data-siw-age-underage]');
  const key = 'siw_age_verified_18';

  if (localStorage.getItem(key) === 'yes') return;

  gate.hidden = false;
  document.documentElement.classList.add('siw-age-gate-open');
  requestAnimationFrame(() => yes?.focus());

  yes?.addEventListener('click', () => {
    localStorage.setItem(key, 'yes');
    gate.hidden = true;
    document.documentElement.classList.remove('siw-age-gate-open');
  });

  no?.addEventListener('click', () => {
    if (underage) underage.hidden = false;
    yes?.setAttribute('hidden', '');
    no?.setAttribute('hidden', '');
    panel?.focus();
  });

  gate.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = [...gate.querySelectorAll('button:not([hidden]):not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden && element.offsetParent !== null);

    if (!focusable.length) {
      event.preventDefault();
      panel?.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  };

  // Sequence with the tiger entry. If the entry is up, the age gate holds until the
  // visitor has entered, so the two full-screen surfaces are never stacked.
  if (document.documentElement.classList.contains('siw-entry-armed')) {
    document.addEventListener('siw:entered', start, { once: true });
    // If the entry's own failsafe disarms it without ever firing siw:entered,
    // the age gate must still appear rather than be silently skipped.
    window.setTimeout(() => {
      if (!document.documentElement.classList.contains('siw-entry-armed')) start();
    }, 6500);
  } else {
    start();
  }
})();
